import React, {Component} from "react";
import * as _ from "lodash";
import {connect} from "react-redux";
import * as actions from "../actions";
import {Link} from "react-router-dom";
import ContentLoader from "react-content-loader";
import {toggleRightBar} from "../util/utility";
//image
import firebase from "../../src/assets/libs/firebase";
import {getUserDetail, USER} from "../util/account_management";

import moment from "moment";
import "firebase/firestore";

import {getEncryptedIdForBroadcaster} from "../util/broadcast_util";

class Notification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notificationLists: [],
        };
    }

    componentWillUnmount() {
    }

    /**
     * This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.notificationDataList &&
            nextProps.notificationDataList.hasOwnProperty("notificationDataList") &&
            nextProps.notificationDataList.notificationDataList !== null
        ) {
            this.setState({
                notificationLists: nextProps.notificationDataList.notificationDataList,
            });
            this.props.resetNotificationList();
        }
    }

    /**
     * listener for click action on view button. we use this to display the detail view of notification
     * @param e
     */
    viewDetailNotification = (e) => {
        e.preventDefault();

        var x = document.getElementById(`notification-viewMore-${e.target.id}`);
        var element = document.getElementById(e.target.id);

        if (x.style.display === "table") {
            x.style.display = "none";
            element.innerText = "View";
        } else {
            x.style.display = "table";
            element.innerText = "Hide";
            this.updateNotificationReadStatus(e.target.id);
        }
    };

    /**
     * listener for updating the read status of notification
     * @param notification_id
     */
    updateNotificationReadStatus = (notification_id) => {
        var index = _.findIndex(this.state.notificationLists, {
            id: notification_id,
        });

        if (!this.state.notificationLists[index].read) {
            const db = firebase.firestore();
            const settings = {};
            db.settings(settings);

            db.collection("users")
                .doc(getUserDetail(this.props, USER, "user_id"))
                .collection("notifications")
                .doc(notification_id)
                .update({
                    read: true,
                })
                .then(function () {
                    //console.log("Document successfully written!");
                });

            const notificationLists = this.state.notificationLists;
            notificationLists[index].read = true;

            this.setState({
                notificationLists,
            });
        }
    };

    // formats the title as per type of notification
    getFormattedTitle = (notification) => {
        return notification.type === 1100 || notification.type === 1000 ? (
            <p>
                <strong>{notification.title.split(" ")[0]}</strong>{" "}
                {notification.title.substr(notification.title.indexOf(" ") + 1)}
            </p>
        ) : notification.type === 300 ? (
            <p>
                {notification.title.substring(0, notification.title.lastIndexOf(" "))}{" "}
                <strong>{notification.title.split(" ").splice(-1)}</strong>
            </p>
        ) : (
            <p>{notification.title}</p>
        );
    };

    //Accept availability request
    doAvailabilityRequest = (notificationDetail) => {
        this.props.setNotificationDataFromNotificationPanel(notificationDetail);
        toggleRightBar();
        this.props.showAcceptOneToOneAvailabilityDialog(notificationDetail);
    };

    getAvailabilityURL = (notification) => {
        const broadcastID = getEncryptedIdForBroadcaster(notification.data.broadcast_id);
        return `/broadcaster/availability/requests?broadcast_id=${broadcastID}`;
    };

    getFollowerLink = (notification) => {
        if (notification.hasOwnProperty("data") && notification.data && notification.data.hasOwnProperty("user_id") && notification.data.user_id) {
            const user_id_encrypted = getEncryptedIdForBroadcaster(notification.data.user_id);
            return (
                <Link to={`/broadcaster/user/profile/${user_id_encrypted}`} onClick={toggleRightBar}>
                    View follower
                </Link>
            )
        } else {
            return (
                <Link to="/broadcaster/followers" onClick={toggleRightBar}>
                    View followers
                </Link>
            )
        }
    }

    render() {
        return (
            <div>
                <div className="rightNotification" id="rightNotification">
                    <div className="right-notification">
                        <h4>
                            <strong>Notifications</strong>
                        </h4>

                        {this.props.notificationDataList.isFetching ? (
                            <ContentLoader
                                height={240}
                                speed={1}
                                primaryColor="#f3f3f3"
                                secondaryColor="#ecebeb"
                            >
                                <rect x="72" y="20" rx="4" ry="4" width="200" height="20"/>
                                <rect x="72" y="80" rx="4" ry="4" width="200" height="20"/>
                                <rect x="72" y="140" rx="4" ry="4" width="200" height="20"/>
                                <rect x="72" y="200" rx="4" ry="4" width="200" height="20"/>
                                <circle cx="36" cy="30" r="22"/>
                                <circle cx="36" cy="90" r="22"/>
                                <circle cx="36" cy="150" r="22"/>
                                <circle cx="36" cy="210" r="22"/>
                            </ContentLoader>
                        ) : this.state.notificationLists.length === 0 ? (
                            <p>Sorry, no notifications at the moment</p>
                        ) : (
                            <ul>
                                {
                                    this.state.notificationLists.length > 0 &&
                                    _.map(this.state.notificationLists, (notification) => {
                                        return (
                                            <li key={notification.id} id={`notification-${notification.id}`}>
                                                <div className="vertical-container-100">
                                                    <div className="vertically-top">
                                                        {
                                                            notification.image &&
                                                            notification.image.length > 0 ? (
                                                                notification.read ? (
                                                                    <img
                                                                        style={{opacity: "0.5"}}
                                                                        src={notification.image}
                                                                        alt="user profile"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={notification.image}
                                                                        alt="user profile"
                                                                    />
                                                                )
                                                            ) : notification.read ? (
                                                                <img
                                                                    style={{opacity: "0.5"}}
                                                                    src={
                                                                        "https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/Account-icon%403x.png"
                                                                    }
                                                                    alt="user profile"
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={
                                                                        "https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/Account-icon%403x.png"
                                                                    }
                                                                    alt="user profile"
                                                                />
                                                            )
                                                        }
                                                    </div>
                                                    <div className="vertically-top">
                                                        {this.getFormattedTitle(notification)}
                                                        <p className="float-left small">
                                                            {moment(notification.send_at.toDate()).fromNow()}
                                                        </p>
                                                        <p className="float-right small">
                                                            <a
                                                                id={notification.id}
                                                                href="#"
                                                                onClick={(ev) => {
                                                                    ev.preventDefault();
                                                                    this.viewDetailNotification(ev);
                                                                }}
                                                                title=""
                                                                data-value="View"
                                                            >
                                                                View
                                                            </a>
                                                        </p>
                                                        <div
                                                            className="view-more"
                                                            id={`notification-viewMore-${notification.id}`}
                                                        >
                                                            <p>{notification.message}</p>
                                                            {[1000, 1100, 1200].indexOf(notification.type) >
                                                            -1 ? (
                                                                <Link
                                                                    to={`/following/${getEncryptedIdForBroadcaster(
                                                                        notification.data.broadcaster_id
                                                                    )}`}
                                                                    onClick={toggleRightBar}
                                                                >
                                                                    View broadcaster
                                                                </Link>
                                                            ) : notification.type === 300 ? (
                                                                <Link
                                                                    to="/broadcaster/wallet"
                                                                    onClick={toggleRightBar}
                                                                >
                                                                    View my wallet
                                                                </Link>
                                                            ) : notification.type === 200 ? (
                                                                this.getFollowerLink(notification)
                                                            ) : notification.type === 1300 ? (
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    onClick={() => {
                                                                        this.doAvailabilityRequest(
                                                                            notification && notification
                                                                        );
                                                                    }}
                                                                >
                                                                    Accept 1-on-1 request
                                                                </a>
                                                            ) : notification.type === 1400 ? (
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    onClick={() => {
                                                                        this.doAvailabilityRequest(
                                                                            notification && notification
                                                                        );
                                                                    }}
                                                                >
                                                                    Accept group request
                                                                </a>
                                                            ) : (
                                                                notification.type === 1500
                                                                    ?
                                                                    (
                                                                        <Link
                                                                            to={this.getAvailabilityURL(notification)}
                                                                            onClick={toggleRightBar}
                                                                        >
                                                                            Check availability request
                                                                        </Link>
                                                                    )
                                                                    :
                                                                    (
                                                                        <Link
                                                                            to="/broadcaster/create/broadcast"
                                                                            onClick={toggleRightBar}
                                                                        >
                                                                            Broadcast now
                                                                        </Link>
                                                                    )
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })
                                }
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        account_management: state.account_management,
        notificationDataList: state.notificationDataList,
    };
}

export default connect(mapStateToProps, actions)(Notification);
